import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VueMeta from "vue-meta";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

import App from "./App.vue";
import Home from "./Home.vue";
import Upload from "./Upload.vue";
import Dashboard from "./Dashboard.vue";
import Edit from "./Edit.vue";
import variables from "../../api/variables.json";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueMeta);
Vue.use(VueRouter);
Vue.directive("router-back", {
    bind(el) {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            router.go(-1);
        });
    },
});

const store = new Vuex.Store({
    state: {
        token: null,
        userId: null,
    },
    mutations: {
        setAuthentication(state, { token, userId }) {
            state.token = token;
            state.userId = userId;
        },
    },
    getters: {
        isAuthenticated(state) {
            return !!state.token;
        },
        token(state) {
            return state.token;
        },
        userId(state) {
            return state.userId;
        },
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],
});

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/upload",
            name: "upload",
            component: Upload,
            beforeEnter: (to, from, next) => {
                if (!store.getters.isAuthenticated) {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
            beforeEnter: (to, from, next) => {
                if (!store.getters.isAuthenticated) {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
        },
        {
            path: "/dashboard/:id",
            name: "edit-map",
            component: Edit,
            beforeEnter: (to, from, next) => {
                if (!store.getters.isAuthenticated) {
                    next({ name: "login" });
                } else {
                    next();
                }
            },
        },
        {
            path: "/login",
            name: "login",
            beforeEnter: (to, form, next) => {
                const url = new URL(window.location.href);
                const token = url.searchParams.get("token");
                const userId = url.searchParams.get("id");

                if (!token || !userId) {
                    const login =
                        variables.host +
                        "/api/login?state=" +
                        encodeURIComponent(
                            JSON.stringify({
                                callback:
                                    url.protocol + "//" + url.host + "/login",
                                redirect:
                                    url.pathname !== "login"
                                        ? url.protocol +
                                          "//" +
                                          url.host +
                                          url.pathname
                                        : undefined,
                            })
                        );
                    return window.location.replace(login);
                }

                store.commit("setAuthentication", { token, userId });
                const stateString = decodeURIComponent(
                    url.searchParams.get("state")
                );
                const state = JSON.parse(stateString);
                if (state && state.redirect)
                    window.location.replace(state.redirect);
                else next("/");
            },
        },
        {
            path: "/logout",
            name: "logout",
            beforeEnter: (to, from, next) => {
                store.commit("setAuthentication", {
                    token: null,
                    userId: null,
                });
                next(from);
            },
        },
    ],
});

new Vue({
    render: (h) => h(App),
    store: store,
    router: router,
}).$mount("#app");
